import {
  JsonapiEntity,
  attribute,
  entity,
  relationship,
} from '@talisdev/jsonapi-transformers';

import { Bookstore } from './bookstore';
import { CitationStyle } from './citation-style';
import { Importance } from './importance';
import { License } from './license';
import { ListAccess } from './list-access';
import { Period } from './period';
import { Report } from './report';
import { Tag } from './tag';

@entity({ type: 'tenants' })
export class Tenant extends JsonapiEntity<Tenant> {
  @attribute() base_uri: string;
  @attribute() default_list_access: ListAccess | null;
  @attribute() login_provider: string;
  @attribute() name: string;
  @attribute() persona_host: string;
  @attribute() short_code: string;
  @attribute() active_locales: string[];
  @attribute() default_locale: string;
  @attribute() required_item_importances: string;
  @attribute() enable_talis_reader_workflow: boolean;
  @attribute() file_upload_cc_preference?: string;
  @attribute() file_upload_allow_upload_to_non_cc_resources: boolean;
  @relationship() bookstores: Bookstore[];
  @relationship() citation_styles: CitationStyle[];
  @relationship() importances: Importance[];
  @relationship() licenses: License[] | null;
  @relationship() periods: Period[] | null;
  @relationship() reports: Report[] | null;
  @relationship() tags: Tag[] | null;
}

export enum TenantType {
  ASPIRE = 'aspire',
  COURSEFLOW = 'courseflow',
}
